import './InviteSignup.css';
import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { auth, db, functions } from '../services/firebase';
import { doc, getDoc, updateDoc, setDoc, arrayUnion } from 'firebase/firestore';
import { createUserWithEmailAndPassword } from 'firebase/auth';
function InviteSignup() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [passwordError, setPasswordError] = useState('');

  const inviteToken = searchParams.get('token');
  const companyId = searchParams.get('companyId');
  const licenseId = searchParams.get('licenseId');

  useEffect(() => {
    async function fetchInvite() {
      setLoading(true);
      setStatus('');
      try {
        if (!companyId || !licenseId || !inviteToken) {
          setStatus('Invalid invite link.');
          setLoading(false);
          return;
        }
        const companyDoc = await getDoc(doc(db, 'companies', companyId));
        if (!companyDoc.exists()) {
          setStatus('Company not found.');
          setLoading(false);
          return;
        }
        const companyData = companyDoc.data();
        const license = (companyData.licenses || []).find(l => l.id === licenseId && l.inviteToken === inviteToken && l.status === 'invited');
        if (!license) {
          setStatus('Invite not found or already used.');
          setLoading(false);
          return;
        }
        setInvite({ ...license, companyId, companyName: companyData.name });
        setLoading(false);
      } catch (err) {
        setStatus('Error loading invite: ' + err.message);
        setLoading(false);
      }
    }
    fetchInvite();
  }, [companyId, licenseId, inviteToken]);

  const handleSignup = async (e) => {
    e.preventDefault();
    setStatus('');
    setPasswordError('');
    if (!invite) return;
    if (password !== confirmPassword) {
      setPasswordError('Passwords do not match.');
      return;
    }
    if (password.length < 6) {
      setPasswordError('Password must be at least 6 characters.');
      return;
    }
    try {
      setStatus('Creating account...');
      // Create user in Firebase Auth
      const credential = await createUserWithEmailAndPassword(auth, invite.email, password);
      const userId = credential.user.uid;
      // Create user doc
      await setDoc(doc(db, 'users', userId), {
        email: invite.email,
        name: invite.name, // Use the actual name from the license
        companyId: invite.companyId
      });
      // Update company: add user to members, mark license as assigned
      const companyRef = doc(db, 'companies', invite.companyId);
      const companyDoc = await getDoc(companyRef);
      if (!companyDoc.exists()) throw new Error('Company not found');
      const companyData = companyDoc.data();
      await updateDoc(companyRef, {
        members: arrayUnion(userId),
        licenses: companyData.licenses.map(l =>
          l.id === invite.id ? { ...l, email: invite.email, name: invite.name, assigned: true, status: 'assigned', inviteToken: null } : l
        )
      });
      setStatus('Account created! Redirecting to login...');
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setStatus('Failed to create account: ' + (err && err.message ? err.message : JSON.stringify(err)));
    }
  };



  if (loading) return <div className="invite-signup-container"><p>Loading invite...</p></div>;
  if (status && !status.startsWith('Account created!')) return <div className="invite-signup-container"><p style={{ color: 'red' }}>{status}</p></div>;
  if (!invite) return null;

  return (
    <div className="invite-signup-container">
      <h2>Accept Your Invite</h2>
      <p>You're joining <b>{invite.companyName}</b> as <b>{invite.email}</b></p>
      <form onSubmit={handleSignup}>
        <div>
          <label>Password</label>
          <input type='password' value={password} onChange={e => setPassword(e.target.value)} required style={{ width: '100%', marginBottom: 12 }} />
        </div>
        <div>
          <label>Confirm Password</label>
          <input type='password' value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required style={{ width: '100%', marginBottom: 12 }} />
        </div>
        {passwordError && <div style={{ color: 'red', marginBottom: 8 }}>{passwordError}</div>}
        <button type='submit' style={{ width: '100%', padding: 12, background: '#4A90E2', color: '#fff', border: 'none', borderRadius: 4 }}>Create Account</button>
      </form>
      {status && status.startsWith('Account created!') && <div style={{ marginTop: 12, color: 'green' }}>{status}</div>}
    </div>
  );
  }
  
export default InviteSignup; 